import React from 'react';
import ShapeRect from './ShapeRect';
import { type TextProps } from '../objects/EmbeddedTextBehaviorsV2';
import type Shape from '../objects/Shape';
import tools from '../tools';

class ShapeText extends ShapeRect {
  textProps: TextProps = {
    allowedStyles: 'any',
    location: 'inside',
    textAlign: 'user',
    verticalAlign: 'none',
    fontSize: 'user',
    overflow: 'visible',
    wrapText: 'user',
    margins: 'scale',
  };

  static iconClass() {
    return 'fa-regular fa-text';
  }

  static renderIcon() {
    return <aha-icon icon={this.iconClass()} />;
  }

  static defaultWidth() {
    return 20;
  }

  static defaultHeight() {
    return 20;
  }

  hasFixedDimensions() {
    return false;
  }

  hasExternalContent() {
    return this.canvas?.isHTMLExport();
  }

  constructor(fabricObject: Shape) {
    super(fabricObject);

    fabricObject.uniformScaling = true;
    fabricObject.strokeWidth = 0;
    fabricObject.fontSize ||= 14;
  }

  changedToShape() {
    super.changedToShape();

    // Reset any background and border styling.
    this.fabricObject.set('fill', null);
    this.fabricObject.set('stroke', null);
  }

  tools() {
    return [tools.ToolShapeType];
  }

  allowedStyleCopyPasteFields(): string[] {
    return [];
  }
}

export default ShapeText;
